import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";
import { error } from 'styles/theme';

export const ErrorFallbackStyles = muiStyled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 12,
    '.error-text': {
        color: error
    }
}));
